<h2 [attr.data-testid]="data.message + '_message'">{{ data.message }}</h2>
@if (data.name) {
  <main [attr.data-testid]="data.name" [innerHTML]="data.name + '?'"></main>
}
@if (data.endMessage) {
  <h3>{{ data.endMessage }}</h3>
}
<footer>
  <button
    [attr.data-testid]="'dialog_no_button'"
    class="button-color"
    id="no-button"
    [mat-dialog-close]="false"
    mat-raised-button
    type="button"
    >
    No
  </button>
  <button
    [attr.data-testid]="'dialog_yes_button'"
    class="button-color"
    id="yes-button"
    [mat-dialog-close]="true"
    mat-raised-button
    type="button"
    >
    Yes
  </button>
</footer>
<mat-icon
  [attr.data-testid]="'clear_button'"
  (click)="closeDialog()"
>clear</mat-icon>
